// supported languages (en is default)
import 'moment/locale/cs'

// external libs
import moment from 'moment'

moment.locale('cs-CZ')

export default moment
